import { render, staticRenderFns } from "./SecretType.vue?vue&type=template&id=1b8f5ba7&"
import script from "./SecretType.vue?vue&type=script&lang=js&"
export * from "./SecretType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports